import { create } from 'zustand';
import { persist } from 'zustand/middleware';
const REFRESH_ENDPOINT = '/api/v1/auth/token/refresh/';
export const useAuthStore = create()(persist((set, get) => ({
    accessToken: null,
    activeCompanyId: null,
    setAccessToken: (access) => set({ accessToken: access }),
    setActiveCompany: (companyId) => set({ activeCompanyId: companyId }),
    refresh: async () => {
        try {
            const res = await fetch(REFRESH_ENDPOINT, {
                method: 'POST',
                credentials: 'include', // send the HttpOnly refresh cookie
                headers: { 'Content-Type': 'application/json' },
                body: '{}',
            });
            if (!res.ok)
                return null;
            const data = (await res.json());
            set({ accessToken: data.access });
            return data.access;
        }
        catch {
            return null;
        }
    },
    logout: () => set({ accessToken: null, activeCompanyId: null }),
}), {
    name: 'vulcan-auth',
    // Persist only the company selection; never persist access tokens.
    partialize: (state) => ({ activeCompanyId: state.activeCompanyId }),
}));
